import React, { useState } from "react";
import Header from "./LayoutIntro/Header";
import Sidebar from "./LayoutIntro/Sidebar";
import FooterIntro from "./LayoutIntro/FooterIntro";
import LokalaiInfo from "./aboutComponent/LokalaiIntro";
import OurStory from "./aboutComponent/ourStory";
import MissionSection from "./aboutComponent/MissionSeciton";
import WhyUs from "./aboutComponent/Whyus";

const About = () => {
  return (
    <>
      <OurStory />
      <LokalaiInfo />
      <MissionSection />
      <WhyUs />
    </>
  );
};

export default About;
